import React, {useMemo} from 'react';

import {IUseCustomTableArgs} from 'components/@common/widgets/custom-table/custom-table';

import {IRiskDocumentsDto} from '../api/types';
import {EditRisksDocumentsForm} from '../ui/form/edit-risks-documents-form';

export const useRisksDocumentsColumns = (
    tableData: IRiskDocumentsDto[] | undefined,
    fetchData: () => Promise<void>
): IUseCustomTableArgs['columns'] =>
    useMemo(
        () => [
            {
                title: 'Код риска',
                dataIndex: 'riskCode',
                render: (value: number, fields: IRiskDocumentsDto) => (
                    <EditRisksDocumentsForm
                        fields={fields}
                        value={value}
                        fetchData={fetchData}
                    />
                ),
                width: '20%'
            },
            {title: 'Наименование риска', dataIndex: 'riskName'},
        ],
        [tableData, fetchData]
    );
